import { Route, Switch, useHistory } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import Login from "./pages/Account/Login";
import SignUp from "./pages/Account/Signup";
import PrivateRoute from "./pages/Account/PrivateRoute";
import UpdateProfile from "./pages/Account/UpdateProfile";
import Profile from "./pages/Profiles/Profile";
import ForgotPassword from "./pages/Account/ForgotPassword";
import NewContract from "./components/Admin/Contracts/NewContract";
import AllContracts from "./components/Admin/Contracts/AllContracts";
import Navigation from "./components/Nav/Navigation";
import ContractsPage from "./pages/Contracts/ContractsPage";
import CheckUserData from "./components/User/CheckUserData";
import ServicePage from "./components/Admin/ServicePage";
// import ComingSoon from "./components/ComingSoon/ComingSoon"
import PeoplePage from "./pages/People/PeoplePage";
import UserProfile from "./pages/Profiles/UserProfile";
import TasksPage from "./pages/Profiles/TasksPage";
import SkillsPage from "./pages/Profiles/SkillsPage";

import AdminPage from "./pages/AdminPage/AdminPage";
import StartPage from "./pages/StartPage/StartPage";

import PageInfo from "./pages/Info/PageInfo";
import PrivacyPage from "./pages/Privacy/PrivacyPage";

import "./styles.scss";
import Container from "./components/UI/Container/Container";
import SmileyBar from "./components/UI/SmileyBar/SmileyBar";

function App() {
  return (
    <AuthProvider>
      <Container>
        <Switch>

          <PrivateRoute path="/" component={StartPage} exact />
          
          {/* Admin stuff 
              secure it! */}
          <PrivateRoute path="/admin" exact component={AdminPage} />
          <PrivateRoute path="/admin/service123" exact component={ServicePage} />
          <PrivateRoute path="/admin/contracts" exact component={AllContracts} />
          <PrivateRoute path="/admin/new-contract" exact component={NewContract} />

          {/* All Users' Stuff */}
          <PrivateRoute path="/users" exact component={PeoplePage} />
          <PrivateRoute path="/users/:userID" exact component={UserProfile} />
          <PrivateRoute path="/users/skills/:userID" exact component={SkillsPage} />
          {/* Personal Stuff */}
          <PrivateRoute path="/profile" exact component={Profile}  />
          <PrivateRoute path="/profile/update-profile" exact component={UpdateProfile} />
          <PrivateRoute path="/profile/skills" exact component={SkillsPage} />
          <PrivateRoute path="/profile/contracts" exact component={TasksPage} />
          <PrivateRoute path="/profile/info" exact component={PageInfo} />

          <PrivateRoute path="/contracts" exact component={ContractsPage} />

          {/* LOGIN */}
          <Route path="/login" component={Login} exact />
          <Route path="/signup" component={SignUp} exact />
          <Route path="/forgot-password" component={ForgotPassword} />

          {/* Service */}
          <PrivateRoute path="/check-user-data" exact component={CheckUserData} />

          {/* Other */}
          <Route path="/privacy" exact component={PrivacyPage} />
         
          
        </Switch>
        <SmileyBar/>
      </Container>
      <Navigation />
    </AuthProvider>
  );
}

export default App;
